import type { FeedProduct } from "@/features/feed/contract"
import { feedMoney } from "@/features/feed/map-product"
import { compareMoney, moneyToNumber, subtractMoney } from "@/lib/money"
import type { GA4Item } from "@/platform/observability/analytics/v2/types/google"

interface FeedItemOptions {
  index?: number
  item_list_id?: string
  item_list_name?: string
}

export const buildGA4ItemFromFeedProduct = (product: FeedProduct, options?: FeedItemOptions): GA4Item => {
  const price = feedMoney(product.price)
  const was = product.compareAtPrice != null ? feedMoney(product.compareAtPrice) : undefined

  return {
    item_id: product.id,
    item_name: product.title,
    price: moneyToNumber(price),
    quantity: 1,
    discount: was != null && compareMoney(was, price) > 0 ? moneyToNumber(subtractMoney(was, price)) : undefined,
    index: options?.index,
    item_list_id: options?.item_list_id,
    item_list_name: options?.item_list_name,
  }
}
